import React from 'react';
import PropTypes from 'prop-types';
import { Loader, SvgIcon } from '@adsk/bim360-matrix-react-components';
import defaultThumbnail from '../assets/images/icons/icon-file-thumbnail.svg';
import deletedOverlayThumbnail from '../assets/images/icons/icon-activity-deleted.svg';
import classNames from 'classnames';

const ChangesetThumbnail = ({ isLoading, thumbnailUrl, hasDeletedOverlay }) => {
  const changesetThumbnailClassNames = classNames(
    'ChangesetThumbnail__content', 'ChangesetThumbnail__thumbnail', {
      'ChangesetThumbnail__thumbnail--deleted': hasDeletedOverlay,
    });
  let component;

  if (isLoading) {
    component = <Loader className="ChangesetThumbnail__content" />;
  } else if (thumbnailUrl) {
    component = <React.Fragment>
      <img className={changesetThumbnailClassNames} src={thumbnailUrl} />
      {hasDeletedOverlay && <SvgIcon height="36px" width="36px">{deletedOverlayThumbnail}</SvgIcon>}
    </React.Fragment>;
  } else {
    component = <SvgIcon height="90px" width="90px">{defaultThumbnail}</SvgIcon>;
  }

  return (
    <div className="ChangesetThumbnail">
      {component}
    </div>
  );
};

ChangesetThumbnail.displayName = 'ChangesetThumbnail';

ChangesetThumbnail.propTypes = {
  isLoading: PropTypes.bool,
  thumbnailUrl: PropTypes.string,
  hasDeletedOverlay: PropTypes.bool,
};

export default ChangesetThumbnail;
